import { action, observable, makeObservable } from 'mobx';
import {
  getPrimaryRating,
  getReviews,
  getFilterReviews,
  submitFeedback,
} from '../services/bazaarvoice-api';
import config from '../config';
import { setCookie } from '../components/Generic/ReadReview';
class ProductStore {
  limit = 1;
  offset = 0;
  sortValue = 'Rating:desc';
  filterValue = '0';
  ratingData = '';
  reviewData = '';
  sortFilterValue = '&sort=Rating:desc';
  reviewItemId = '';
  preloadBVReviews = false;
  primaryRating = (productIdArray, locale) => {
    this.getPrimaryRatingData(productIdArray, locale)
      .then(data => {
        if (data && data.data && data.data.Results[0]) {
          this.ratingData = data.data.Results[0];
        }
      })
      .catch(err => {
        throw new Error(err);
      });
  };
  getPrimaryRatingData = (productIdArray, locale) => {
    return new Promise((resolve, reject) => {
      getPrimaryRating(productIdArray, locale)
        .then(data => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
          throw new Error(err);
        });
    });
  };
  getReviewsByID = (productId, locale) => {
    getReviews(
      productId,
      this.limit,
      this.offset,
      this.sortFilterValue,
      locale
    ).then(reviews => {
      if (this.ratingData !== '' && reviews && reviews.data) {
        this.reviewData = {
          Results: reviews.data.Results,
          TotalReviewCount: reviews.data.TotalResults,
        };
      }
    });
  };
  loadMoreReviews = (productId, locale) => {
    const newOffset = this.offset + this.limit;
    this.offset = newOffset;
    getReviews(
      productId,
      limit,
      this.offset,
      this.sortFilterValue,
      locale
    ).then(response => {
      this.reviewData.Results = this.reviewData.Results.concat(
        response.data.Results,
              );
      this.limit = response.data.Limit;
    
    });
    
  };
  onChangeSortFilter = (sortFilterValue, productId, locale) => {
    this.limit = config.bazaarvoice[locale].preloadConfig.numberOfReviews;
    this.offset = 0;
    this.sortFilterValue = sortFilterValue;
    this.productReviewFilter(
      productId,
      this.limit,
      this.offset,
      sortFilterValue,
      locale
    );
  };
  productReviewFilter = (productId, limit, offset, sortFilterValue, locale) => {
    getFilterReviews(productId, limit, offset, sortFilterValue, locale).then(
      reviews => {
        this.reviewData = {
          Results: reviews.data.Results,
          TotalReviewCount: reviews.data.TotalResults,
        };
      }
    );
  };
  submitFeedbackByID = (feedback, itemID, locale) => {
    let writeFeedbackData = {};
    writeFeedbackData = {
      ContentId: itemID,
      ContentType: config.bazaarvoice.ContentType,
      FeedbackType: config.bazaarvoice.FeedbackType,
      Vote: feedback,
      localeVal: locale,
    };
    submitFeedback(writeFeedbackData);
    if (feedback === config.bazaarvoice.Positive) {
      setCookie(itemID, 1);
      this.reviewItemId = itemID;
    } else {
      setCookie(itemID, -1);
      this.reviewItemId = itemID;
    }
  };
  getPreloadConfig = locale => {
    this.preloadBVReviews = config.bazaarvoice[locale].preloadEnabled;
    this.limit = config.bazaarvoice[locale].preloadConfig.numberOfReviews;
  };

  constructor() {
    makeObservable(this, {
      limit: observable,
      offset: observable,
      sortValue: observable,
      filterValue: observable,
      ratingData: observable,
      reviewData: observable,
      sortFilterValue: observable,
      reviewItemId: observable,
      primaryRating: action,
      getPrimaryRatingData: action,
      getReviewsByID: action,
      loadMoreReviews: action,
      onChangeSortFilter: action,
      productReviewFilter: action,
      submitFeedbackByID: action,
      getPreloadConfig: action
    });
  }
}
const store = new ProductStore();
export default store;